module.exports = __webpack_public_path__ + "img/dashboard.31b3fb42.png";